import * as React from 'react';
import Menu from '@mui/material/Menu';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";


const JDPCustomButton1 = ({anchorEl, open, handleMenuOpen, handleMenuClose}) => {
    const handleClick = (event) => {
        if (open) {
            handleMenuClose();
        } else {
            handleMenuOpen(event);
        }
    };

    React.useEffect(() => {
        const handleScroll = () => {
            if (open) {
                handleMenuClose();
            }
        };

        if (open) {
            window.addEventListener('scroll', handleScroll);
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [open]);

    return (
        <div className={open ? 'menu-button-container menu-button-container-selected' : 'menu-button-container'}>
            <button
                className={open ? 'menu-button menu-button-selected' : 'menu-button'}
                id="menu-button"
                aria-controls={open ? 'menu-button' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <span>Vehicles for Sale</span>
                {open ? (
                    <KeyboardArrowUpIcon className="menu-arrow-icon" />
                ) : (
                    <KeyboardArrowDownIcon className="menu-arrow-icon" />
                )}
            </button>
            <Menu
                classes={{'paper': 'menu-button-paper'}}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                id="button-dropdown-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                disableScrollLock={true}
                sx={{
                    left: 54,
                    top:84
                }}
                BackdropProps={{
                    sx: {
                        top: 84
                    }
                }}
            >
                <span className={'menu-button-cat'}>Cars</span>
                <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                    <a className={'menu-button-link'} href="https://www.jdpower.com/cars-for-sale">Cars for Sale</a>
                </MenuItem>
                <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                    <a className={'menu-button-link'} href="https://www.jdpower.com/sell-my-car-2">Sell My Car</a>
                </MenuItem>
                <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                    <a className={'menu-button-link'} href="https://www.jdpower.com/quotes">Free Dealer Price Quote</a>
                </MenuItem>
                <Divider className={'menu-divider'} />
                <span className={'menu-button-cat'}>Specialty Vehicles</span>
                <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                    <a className={'menu-button-link'} href="https://www.jdpower.com/rvs-for-sale">RVs For Sale</a>
                </MenuItem>
                <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                    <a className={'menu-button-link'} href="https://www.jdpower.com/motorcycles-for-sale">Motorcycles For Sale</a>
                </MenuItem>
                <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                    <a className={'menu-button-link'} href="https://www.jdpower.com/boats-for-sale">Boats For Sale</a>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default JDPCustomButton1;